module.exports = __webpack_public_path__ + "img/BigGuns.209183d7.png";